export enum ConversationTypeEnum {
  Text = 1,
  Quote = 2,
  Contract = 3,
  Payment_Request = 4,
  Quote_Accepted = 5,
  Quote_Rejected = 6,
  Payment_Released = 7,
  Contract_Accepted = 8,
  Contract_Rejected = 9,
  Payment_Request_Accepted = 10,
  Payment_Request_Rejected = 11,
  call_started = 12,
  missed_call = 13,
}
